import { useLocation } from 'react-router-dom'

/** Syncs with the current route pathname (requires `BrowserRouter` ancestor). */
export const useNavigationPathname = () => {
  const { pathname } = useLocation()
  return pathname
}
